import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { Mutations } from "@/store/enums/StoreEnums";

@Module
export default class TicketsModule extends VuexModule {
  public requiredNewTicketsList = false;

  get isRequiredTicketsList(): boolean {
    return this.requiredNewTicketsList;
  }

  @Mutation
  [Mutations.MANAGER_TICKETS_TOGGLE_STATE](requiredNewList: boolean) {
    this.requiredNewTicketsList = requiredNewList;
  }
}
